import { Lightbox } from '@components/Lightbox'
import { styled } from 'twin.macro'
import AutosaveStatusHeader from '../../_shared/AutosaveStatusHeader'
import SocialMediaTextSetting from './SocialMediaTextSetting'
import SocialMediaImageSetting from './SocialMediaImageSetting'

type Props = {
  close: () => void
}

const SocialMediaSettingsLightbox = (props: Props) => {
  const { close } = props

  const headerContent = <AutosaveStatusHeader title="社群設定" close={close} />

  const mainContent = (
    <Main tw="space-y-6">
      <SocialMediaImageSetting />
      <SocialMediaTextSetting />
    </Main>
  )

  return <Lightbox close={close} headerContent={headerContent} mainContent={mainContent} />
}

const Main = styled.div`
  padding: 16px 8px;
`

export default SocialMediaSettingsLightbox
